import React, { useState } from 'react';
import { IOSSwitch } from 'src/components/SwitchIos';
import FormControlLabel from '@mui/material/FormControlLabel';
import { PolygonsSwitchLogo } from 'src/components/ViewSpinner/components/PolygonsSwitch/components/PolygonsSwitchLogo';
import { usePolygonsSwitch } from 'src/components/ViewSpinner/components/PolygonsSwitch/hooks/usePolygonsSwitch';
import { useAppMediaQuery } from 'src/hooks/app/useAppMediaQuery';
import Tooltip from '@mui/material/Tooltip';
import { ListOfKeysFilterAllData } from 'src/typings/filter';
import { useComplex } from 'src/hooks/app/use-complex';
import { useStyles } from './styles';

export const PolygonsSwitch: React.FC = () => {
  const styles = useStyles();
  const { getComplexTranslation } = useComplex();
  const { showPolygons, togglePolygonsVisibility } = usePolygonsSwitch();
  const { isXlUp } = useAppMediaQuery();
  const [isHover, setIsHover] = useState(false);
  const tooltip = getComplexTranslation(ListOfKeysFilterAllData.placementStatusModuleName);
  const logoSize = isXlUp ? 28 : 24;
  return (
    <Tooltip
      title={tooltip}
      placement="top"
      arrow
      open={isHover}
      onClose={() => setIsHover(false)}
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      <div className={styles.polygonsSwitchWrapper} onMouseEnter={() => setIsHover(true)}>
        <FormControlLabel
          style={{ marginRight: '0px', paddingRight: '0px' }}
          control={(
            <div className={styles.control}>
              <IOSSwitch
                checked={showPolygons}
                onChange={togglePolygonsVisibility}
                name="checkedPolygons"
              />
              <PolygonsSwitchLogo size={logoSize} />
            </div>
          )}
          label={<></>}
          labelPlacement="end"
        />
      </div>
    </Tooltip>
  );
};
